import ReactGA from 'react-ga';

ReactGA.initialize('UA-161258592-1');

export default ReactGA;